<template>
    <div>
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong>-->
<!--        added a banned word-->
<!--        <strong>{{ $_.get(activity, "payload.name") }} </strong>-->
        <span v-html="$t('notification.bannedWordCreated', {user:$_.get(activity, 'actorUser.name'),bWord:$_.get(activity, 'payload.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "BannedWordCreated",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
